import { requestCommonSearch } from "../../../../actions/common/requests";
import defaultErrorHandler from "../../../../actions/global/default-error-handler";
import settings from "../../../../utils/settings";


const url = `${settings.accountsUrl}api/admin/`;
const ENDPOINT = "agreement";

export const getStaticPages = (page = 0, size = 20, sort = "startDate,desc", filters = [], callback, setLoading) => dispatch => {
  if (setLoading) setLoading(true);
  requestCommonSearch(ENDPOINT, page, size, sort, filters, url)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, "", true));
    })
    .finally(() => {
      if (setLoading) setLoading(false);
    });
};



// WEBPACK FOOTER //
// ./src/views/pages/static-pages/requests/getStaticPages.js